import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/auth/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({
            name: 'home',
          })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          route => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: 'home',
              }
            : {
                ...routeFrom,
              }
        )
      },
    },
  },
  {
    path: '/member',
    name: 'Members',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/member/listMember.vue')),
    meta: {
      authRequired: true,
    },
  },

  {
    path: '/newmember',
    name: 'NewMember',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/member/newMember.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editMember',
    name: 'editMember',
    component: () => lazyLoadView(import('@views/member/editmember.vue')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/newPayment',
    name: 'newPayment',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/payment/newPayment.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/unpaid',
    name: 'unpaid',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/report/unpaidMembers.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/invoice',
    name: 'invoice',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/payment/invoice.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/salesReport',
    name: 'salesReport',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/report/salesReport.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/attendance',
    name: 'Attendance',
    props: route => ({
      ...route.params,
    }),
    component: () => lazyLoadView(import('@views/attendance/attendance.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/404').default,

    props: true,
  },
  {
    path: '*',
    redirect: '404',
  },
]

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@views/loading').default,
    error: require('@views/timeout').default,
    delay: 400,
    timeout: 100000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
